import React from "react";
import PropTypes from "prop-types";
import CountUp from "react-countup";

const PtoUserDisplay = ({ data }) => {
  const ptoData = {
    "Yearly Completed": { value: data ? data.yearly : "0.00", suffix: " days" },
    Reserved: { value: data ? data.reserved : "0.00", suffix: " days" }
  };
  return (
    <div
      className="project-metrics"
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(2, 1fr)`
      }}
    >
      {Object.keys(ptoData)
        .filter((key) => ptoData[key])
        .map((key, i) => (
          <div key={i} className="content-wrapper">
            <fieldset>
              <legend className="pto-legend">{key}</legend>
            </fieldset>
            <CountUp
              className="counter pto-legend"
              suffix={ptoData[key].suffix || " days"}
              decimals={2}
              end={ptoData[key].value}
            />
          </div>
        ))}
    </div>
  );
};

PtoUserDisplay.propTypes = {
  data: PropTypes.object.isRequired
};

export default PtoUserDisplay;
